import axios, { type AxiosInstance } from 'axios';

import { config } from '../config';

export type UnauthorizedHandler = () => void;

let getToken: (() => string | null) | null = null;
let unauthorizedHandler: UnauthorizedHandler | null = null;

const createClient = (baseURL: string): AxiosInstance => {
  const instance = axios.create({
    baseURL,
    timeout: 15_000
  });

  instance.interceptors.request.use((request) => {
    if (getToken) {
      const token = getToken();
      if (token) {
        request.headers = request.headers ?? {};
        request.headers.Authorization = `Bearer ${token}`;
      }
    }

    request.headers = request.headers ?? {};
    request.headers['X-Requested-With'] = 'SMS-Dashboard';
    return request;
  });

  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401 && unauthorizedHandler) {
        unauthorizedHandler();
      }
      return Promise.reject(error);
    }
  );

  return instance;
};

export const apiClient = createClient(config.apiBaseUrl);
export const supportClient = createClient(config.apiSupportBaseUrl);

export const registerAuthHandlers = ({
  tokenResolver,
  onUnauthorized
}: {
  tokenResolver: () => string | null;
  onUnauthorized: UnauthorizedHandler;
}) => {
  getToken = tokenResolver;
  unauthorizedHandler = onUnauthorized;
};
